import { put, select } from 'redux-saga/effects';
import { UserId } from 'features/users/types';
import { SourceDetails } from 'features/layout/types';
import {
  selectHistoricalSpeakers,
  selectOrderedStreams,
  speakersUpdated,
} from 'features/layout/features/order/orderSlice';
import { orderChanged } from 'features/layout/actions';
import { logger } from 'utils/logger';

export function* updateOrderSaga(userIdOrIds: UserId | UserId[]) {
  const userIds = Array.isArray(userIdOrIds) ? userIdOrIds : [userIdOrIds];

  const streams: SourceDetails[] = yield select(selectOrderedStreams);
  const speakers: SourceDetails[] = yield select(selectHistoricalSpeakers);

  const existingStreamIds = new Set(streams.map((s) => s.userId));
  const existingSpeakerIds = new Set(speakers.map((s) => s.userId));

  const newStreamUserIds = userIds.filter((id) => !existingStreamIds.has(id));
  const newSpeakerUserIds = userIds.filter((id) => !existingSpeakerIds.has(id));

  if (newStreamUserIds.length > 0) {
    const newEntries: SourceDetails[] = newStreamUserIds.map((userId) => ({
      userId,
      kind: 'remote',
    }));
    const newStreams = [...streams, ...newEntries];

    logger
      .remote({ system: true, capture: 'layout' })
      .info('[LAYOUT-DEBUG] Adding users to layout', {
        userIds: newStreamUserIds,
        previousCount: streams.length,
        newCount: newStreams.length,
        streams: newStreams.map((s) => ({
          userId: s.userId,
          feedId: s.feedId,
          kind: s.kind,
        })),
      });

    yield put(orderChanged(newStreams));
  }

  if (newSpeakerUserIds.length > 0) {
    const newEntries: SourceDetails[] = newSpeakerUserIds.map((userId) => ({
      userId,
      kind: 'remote',
    }));
    yield put(speakersUpdated([...speakers, ...newEntries]));
  }
}
